module.exports = __webpack_public_path__ + "static/media/thewest-digital-hero-variation-a.4a9a01fc.jpg";